import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Modal, Form, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useCaseDetailsContext from "../../hooks/useCaseDetailsContext";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import swal from 'sweetalert2';
import Preloader from "../Preloader";
import "react-datepicker/dist/react-datepicker.css";
import '../../styles/common.css'
import { getDisplayDateTimeFormat } from "../../util/generalUtills";

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const AddCaseActivity = ({ show, onHide, editId }) => {
  const { id } = useParams();
  const caseCtx = useCaseDetailsContext();
  const {
    actions,
    caseLogsLists,
    loadingCaseDetails,
    errorsCaseDetails,
    changedCaseDetailsStatus,
    resetStatusType,
  } = caseCtx;
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});
  const [files, setFiles] = useState([]);
  const [remark, setRemark] = useState("");

  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
  } = useSelector((state) => state);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(1000);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;

  const [validated, setValidated] = useState(false);
  

  useEffect(() => {
    if (show && id) {
      dispatch(actions.getCaseLogsListById(auth?.token, id, paginate, page, search, sort));
    }
  }, [show, auth, id, paginate, page, search, sort, dispatch, actions]);

  
  useEffect(() => {
    if(id && caseLogsLists && Object.keys(caseLogsLists).length > 0) {
      setFormData({
      });
    }
  }, [caseLogsLists]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide();
    }
  }, [errors, dispatch, onHide]);

  
  useEffect(() => {
    if (changedCaseDetailsStatus?.success) {
    onHide()
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedCaseDetailsStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: resetStatusType });
    }
  }, [changedCaseDetailsStatus, dispatch, onHide, resetStatusType]);


  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{(id && caseLogsLists && Object.keys(caseLogsLists).length > 0) ? t("Show Claim Log") : t("Add Case Activity")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <div className="text-center" style={{ height: '300px', overflow: 'scroll' }}>
                  <Table striped bordered hover>
                    <thead className="thead-light">
                      <tr>
                        <th>Remark</th>
                        <th>Created At</th>
                        <th>Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {caseLogsLists?.length === 0 ? (
                        <tr>
                          <td colSpan="3">No remarks found</td>
                        </tr>
                      ) : (
                        caseLogsLists?.map?.((item, index) => (
                          <tr key={index}>
                            <td>{item?.remark}</td>
                            <td>{getDisplayDateTimeFormat(item?.createdAt)}</td>
                            <td>{item?.createdByCaseLogs?.name} ({item?.createdByCaseLogs?.adminUserType?.name})</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <div className="d-flex justify-content-center">
          <Button variant="dark" onClick={onHide}>
            {t("Close")}
          </Button>
        </div>
      </Modal.Body>
      {loadingCaseDetails && <Preloader />}
    </Modal>
  );
};

export default AddCaseActivity;
